// https://storybook.js.org/tutorials/design-systems-for-developers/react/en/build/
import styled from "styled-components";
import {css} from 'styled-components';

export const Section = styled.section`
  width: 100%;
  padding: 1rem 0;
  position: relative;
    @media (min-width: 768px) {
        padding: 2rem 0;
    }
`;

export const Container = styled.div`
  max-width: var(--content-width-max);
  margin: 0 auto;
  padding: 0 1rem;
  position: relative;
  @media (min-width: 768px) {
    padding: 0 2rem;
  }
`;

export const NarrowContainer = styled(Container)`
  max-width: var(--content-narrow-width-max);
  @media (min-width: 768px) {
    padding: 0 2rem;
  }
  @media (min-width: 1200px) {
    padding: 0 4rem;
  }
`

export const GreyBackground = css`
  background-color: var(--offwhite);
`;

export const GreyWhiteSplitBkg = css`
  background: linear-gradient(0deg, #fff 50%, #E9ECEF 50%)
`
export const WhiteGreySplitBkg = css`
  background: linear-gradient(180deg, #fff 50%, #E9ECEF 50%)
`
